import React from 'react';
import { Typography, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function EligibilityCriteria() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm')); // true for mobile/tablet

  return (
    <div style={{ fontFamily: 'sans-serif', padding: matches ? '16px' : '48px' }}>
      <Typography
        fontFamily='Montserrat'
        fontWeight="700"
        align="center"
        color="#384CFF"
        fontSize={matches ? '32px' : '64px'} // Adjust font size for small screens
      >
        Eligibility Criteria
      </Typography>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: matches ? '16px' : '8px', // Adjust gap for mobile/tablet
          marginTop: matches ? '16px' : '32px', // Adjust margin for mobile/tablet
          flexDirection: matches ? 'column' : 'row', // Stack items vertically on small screens
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: matches ? 30 : 40, // Smaller circle on mobile/tablet
            height: matches ? 30 : 40,
            backgroundColor: '#D9D9D9',
            borderRadius: '50%',
          }}
        >
          <Avatar
            src="https://dbqa318yoj3nn.cloudfront.net/student_graduation.png"
            alt="Student Graduation Icon"
            sx={{ width: matches ? 18 : 24, height: matches ? 18 : 24, backgroundColor: 'transparent' }}
          />
        </div>

        <Typography
          fontFamily='Montserrat'
          fontWeight='700'
          fontSize={matches ? '18px' : '24px'} // Adjust font size for mobile/tablet
          lineHeight='32px'
          textAlign="center"
          color='#12121299'
        >
          Each student shortlisted for the USA Trip must complete these mandatory steps:
        </Typography>
      </div>
    </div>
  );
}
